import * as tslib_1 from "tslib";
import { BaseComponent } from "../../base/base.component";
import { MAP_ROUTE } from "../../../crossconcern/utilities/properties/routename.property";
import { CarouselModel } from "../../../crossconcern/models/carousel.model";
import { NURSERIES_PATH, SPHERE_PATH } from "../../../crossconcern/utilities/properties/path.property";
var NurseryCarouselComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NurseryCarouselComponent, _super);
    function NurseryCarouselComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nurseries = [];
        _this.promotions = [];
        _this.carouselItems = [];
        _this.customOptions = {
            autoWidth: true,
            margin: 20,
            loop: false,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: false,
            dots: false,
            navSpeed: 700,
            nav: true,
            stagePadding: 30,
            navText: [
                "<i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i>",
                "<i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i>"
            ],
            items: 1,
            responsiveRefreshRate: 20,
            responsive: {
                400: {
                    items: 1
                },
                740: {
                    items: 2
                },
                940: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
        };
        return _this;
    }
    NurseryCarouselComponent.prototype.ngOnChanges = function () {
        var _this = this;
        this.carouselItems = [];
        this.promotions.forEach(function (promotion) {
            _this.carouselItems.push(new CarouselModel(null, promotion));
        });
        this.nurseries.forEach(function (nursery) {
            _this.carouselItems.push(new CarouselModel(nursery, null));
        });
    };
    NurseryCarouselComponent.prototype.onResize = function (_) {
        /* this.owlElement.carouselService.refresh();
        this.owlElement.carouselService.update();
        */
        this.owlElement.carouselService._invalidated.width = true;
        this.owlElement.carouselService._trigger("refresh.owl.carousel");
        this.owlElement.carouselService.refresh();
    };
    NurseryCarouselComponent.prototype.onNurseryClick = function (uuid) {
        this.goToRouteByName(MAP_ROUTE, { id: uuid });
    };
    NurseryCarouselComponent.prototype.onPromotionClick = function (promotion) {
        if (promotion.nurseries && promotion.nurseries.length > 0 && promotion.nurseries[0].nursery
            && promotion.nurseries[0].nursery.promotionPhotosphereUuid) {
            this.appComponent.startLoading();
            window.location.href = NURSERIES_PATH + "/" + SPHERE_PATH + "/" +
                promotion.nurseries[0].nursery.uuid + "?start=" + promotion.nurseries[0].nursery.promotionPhotosphereUuid;
        }
    };
    return NurseryCarouselComponent;
}(BaseComponent));
export { NurseryCarouselComponent };
